import Project from "./Project";

export default function MyWork() {
    return (
        <>
            <h1 className="title">My Work <div className="title__underline" /></h1>

            <div className="my-work">
                <Project image={{color: "#10D9D9", isImage: false, text: "Hi-Lo Game", font: "'Wellfleet', cursive", size: "3.5rem", i: false}} title="Hi-Lo Game" website="https://hilo-game.herokuapp.com/">
                    <p>
                        A simple implementation of a game called Skyjo. The game is played with 2-8 players and is
                        multiplayer and playable across multiple devices.
                    </p>
                    <div className="chip chip--inline"><i className="fab fa-node-js" />Node</div>
                    <div className="chip chip--inline"><i className="fab fa-html5" />HTML</div>
                    <div className="chip chip--inline"><i className="fab fa-sass" />SCSS</div>
                    <div className="chip chip--inline"><i className="fab fa-react" />React</div>
                    <div className="chip chip--inline"><i className="fab fa-js" />Javascript</div>
                </Project>
                <Project image={{color: "#39AE48", isImage: false, text: "HTML Component Library", font: "'Raleway', san-serif", size: "2.5rem", i: true}} title="HTML Component Library" website="https://html-component-library.herokuapp.com/">
                    <p>
                        This is a component based UI Kit for building simple web UIs. This is a simple documentation
                        website where you can read how it works and download it to try for yourselves.
                    </p>
                    <div className="chip chip--inline"><i className="fab fa-node-js" />Node</div>
                    <div className="chip chip--inline"><i className="fab fa-html5" />HTML/Pug</div>
                    <div className="chip chip--inline"><i className="fab fa-sass" />SCSS</div>
                    <div className="chip chip--inline"><i className="fab fa-js" />Javascript</div>
                </Project>
                <Project image={{color: "#F18F01", isImage: true, src: "/images/TheCommunityChurchSouthport.png", size: "2.5rem", i: false}} title="The Community Church, Southport" website="" comingSoon="true">
                    <p>
                        The Community Church is the church I am apart of and during my time as an intern there one of
                        the many things I have got up to with them is to redo their website. <strong>The project is
                        still in progress</strong> so more information to follow at a later date.
                    </p>
                    <div className="chip chip--inline"><i className="fab fa-php" />PHP</div>
                    <div className="chip chip--inline"><i className="fab fa-laravel" />Laravel</div>
                    <div className="chip chip--inline"><i className="fab fa-html5" />HTML</div>
                    <div className="chip chip--inline"><i className="fab fa-sass" />SCSS</div>
                    <div className="chip chip--inline"><i className="fab fa-js" />Javascript/Coffeescript</div>
                    <div className="chip chip--inline"><i className="fab fa-html5" />MJML</div>
                    <div className="chip chip--inline"><i className="fas fa-database" />SQL</div>
                </Project>
            </div>
        </>
    );
}
